import React, { FC } from 'react';
import { HeaderLogo } from './logo/HeaderLogo';
import { HeaderLogoNotLogged } from './logo/HeaderLogoNotLogged';
import { HeaderDoctrineLogo } from './HeaderDoctrineLogo';
import styles from './header_content_logo.module.scss';

type Props = {
  loggedIn: boolean;
  source: string;
};

export const HeaderContentLogo: FC<Props> = ({ loggedIn, source }) => (
  <div className={styles.wrapper}>
    {loggedIn ? (
      <HeaderLogo source={source}>
        <HeaderDoctrineLogo loggedIn={loggedIn} />
      </HeaderLogo>
    ) : (
      <HeaderLogoNotLogged source={source}>
        <HeaderDoctrineLogo loggedIn={loggedIn} />
      </HeaderLogoNotLogged>
    )}
  </div>
);
